module.exports = __webpack_public_path__ + "img/cns_maca2.4eb37b22.png";